import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { IdentificacionSection } from '../components/IdentificacionSection';
import { ProblemaRealSection } from '../components/ProblemaRealSection';
import { RevelacionSection } from '../components/RevelacionSection';
import { SolucionSection } from '../components/SolucionSection';
import { OrigenSection } from '../components/OrigenSection';
import { FormularioSection } from '../components/FormularioSection';
import { IdentidadSection } from '../components/IdentidadSection';
import { TransicionSection } from '../components/TransicionSection';
import { FraseFinalSection } from '../components/FraseFinalSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full font-sans selection:bg-[#D90B10] selection:text-white" data-id="element-173">
      <HeroSection data-id="element-174" />
      <IdentificacionSection data-id="element-175" />
      <ProblemaRealSection data-id="element-176" />
      <RevelacionSection data-id="element-177" />
      <SolucionSection data-id="element-178" />
      <OrigenSection data-id="element-179" />
      <FormularioSection data-id="element-180" />
      <IdentidadSection data-id="element-181" />
      <TransicionSection data-id="element-182" />
      <FraseFinalSection data-id="element-183" />
      <Footer data-id="element-184" />
    </main>;
}